import EventGuidelineDelete from './EventGuidelineDelete';

export default EventGuidelineDelete;
